var React = require('react');
var ReactDom = require('react-dom');
var NotificationsDrawer = require('../Views/Feature/Notifications/NotificationsDrawer/notificationsDrawer.jsx');
var defaultFetchOptions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx').defaultFetchOptions;

var bootstrap = (isExperienceEditor) => {
    var fullUrl = "/api/reactforms/GetMemberStatusInfo";

    var instantiateReactElements = (isLoggedIn) => {
        $('.notifications-react-root').each((index, node) => {
            ReactDom.render(
                <NotificationsDrawer isLoggedIn={isLoggedIn}/>,
                node
            );
        });
    };

    if (!isExperienceEditor) {
        fetch(fullUrl, defaultFetchOptions())
            .then((res) => {
                return res.json();
            })
            .then((result) => {
                    var isLoggedIn = result && result.response && result.response.Data && result.response.Data.FirstName
                        ? true
                        : false;
                    instantiateReactElements(isLoggedIn);
                },
                (error) => {
                    instantiateReactElements(false);
                });
    } else {
        instantiateReactElements(false);
    }
};

$(function () {
    if ($ && $(".scWebEditRibbon").length === 0) {
        bootstrap(false);
    } else {
        bootstrap(true);
    }
});